###
Add or remove automatic cart items based on their conditions
###
import Vue from 'vue'
import { execute } from 'library/services/shopify/storefront'

# Vuex module getters
export getters =

	# Helper for retrieving the list of automatic conditions. I'm not applying
	# filtering by startTime / endTime in here because I want to those calculated
	# fresh when needed.
	conditions: (state, getters, rootState) ->
		(rootState.globals.freeGiftWithPurchase?.settings || [])
		.filter (setting) ->
			setting.__typename == 'freeGiftOptions_minimumSubtotalAutomatic_BlockType'

	# Helper for retrieving a list of all handles for free products
	handles: (state, getters) ->
		getters.conditions.map ({ productHandle }) -> productHandle

# Add all listeners and behaviors
export addAutomaticGiftSubscribers = (store) ->

	###########
	# Methods #
	###########

	# Add the gift product to the cart
	addItemToCart = (handle) ->

		# Get the gift variant
		return unless variant = await getPrimaryVariant handle
		return unless variant.availableForSale

		# If the product is already in the cart, then return to prevent duplicates
		return if !!giftLineItem variant

		# Add to cart
		await store.dispatch 'cart/addItem', {
			quantity: 1
			id: variant.id
		}

	# Remove the gift product from the cart
	removeItemFromCart = (handle) ->

		# Validate the handle can be resolved
		return unless variant = await getPrimaryVariant handle
		return unless line = giftLineItem variant

		# Remove from cart
		store.dispatch 'cart/updateLine', {
			id: line.id
			quantity: 0
		}

	###########
	# Helpers #
	###########

	# Get the variant id of a product if it's available to sell
	getPrimaryVariant = (handle) ->
		{ product } = await execute
			variables: { handle }
			query: '''
				query getProductVariants($handle:String!) {
					product(handle:$handle) {
						id
						variants(first:1) {
							edges {
								node {
									id
									availableForSale
								}
							}
						}
					}
				}
			'''
		return product?.variants[0]

	# Get the lineItem of the gift bar (which may not exist)
	giftLineItem = (variant) ->
		store.state.cart.lines.find (line) ->
			line.variant?.id == variant.id

	# Get the active conditions, based on current time
	getActiveConditions = ->
		now = new Date
		store.getters['free-gift/automatic/conditions']
		.filter (condition) -> switch
			when condition.startTime and now < new Date condition.startTime
				return false
			when condition.endTime and now >= new Date condition.endTime
				return false
			else true

	#############
	# Listeners #
	#############

	# We're watching the subtotal of the user's checkout so that we can add or
	# remove the gift product based on a threshold for cart subtotal price
	store.watch(
		(state, getters) -> getters['cart/total']
		(total) -> onTotalChange parseFloat(total)
	)

	# Loop through the conditions and decide whether to add or remove that item
	onTotalChange = (total) ->
		for { productHandle, totalThreshold } in getActiveConditions()
			if total >= totalThreshold
			then addItemToCart productHandle
			else removeItemFromCart productHandle
